<ng-container *ngIf="shouldDisplay">
  <div class="d-flex align-items-center">
    <span *ngIf="debugMode && hasErrors" tooltip="{{'Form has errors' | translate}}" container="body" placement="right" class="btn-circle-icon btn-circle-small btn-danger mr-2">
      <i class="far fa-bug"></i>
    </span>
    <div
      dropdown
      class="form-builder-actions dropdown align-self-center"
      [placement]="dropdownPlacement"
    >
      <button dropdownToggle type="button" class="btn btn-ghost btn-sm" [attr.aria-label]="optionsLabel | translate">
        <i class="fa-regular fa-ellipsis-vertical mr-2"></i>
        {{ optionsLabel | translate }}
      </button>
      <div *dropdownMenu [ngClass]="dropdownMenuClasses">
        <button
          *ngIf="canShowReusableBlocks"
          class="dropdown-item cursor-pointer"
          type="button"
          (click)="handleShowReusableBlocks()"
        >
          <div class="service-context-menu-item">
            <i class="far text-gray fa-folder-open"></i>
            <span>{{ showReusableBlocksLabelKey | translate }}</span>
          </div>
        </button>
        <button
          *ngIf="canCopy"
          class="dropdown-item cursor-pointer"
          type="button"
          (click)="handleCopy()"
        >
          <div class="service-context-menu-item">
            <i class="far text-gray fa-copy"></i>
            <span>{{ copyLabelKey | translate }}</span>
          </div>
        </button>
        <button
          *ngIf="canDownload"
          class="dropdown-item cursor-pointer"
          type="button"
          (click)="handleDownload()"
        >
          <div class="service-context-menu-item">
            <i class="far text-gray fa-arrow-up-from-line"></i>
            <span>{{ downloadLabelKey | translate }}</span>
          </div>
        </button>
        <button
          *ngIf="canOpenHistory"
          class="dropdown-item cursor-pointer"
          type="button"
          (click)="handleHistory()"
        >
          <div class="service-context-menu-item">
            <i class="far text-gray fa-clock-rotate-left"></i>
            <span>{{ historyLabelKey | translate }}</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</ng-container>
